import { createAsyncThunk } from '@reduxjs/toolkit';
import { stationApi, userApi } from 'src/clients/http';
import { IPagination } from 'src/types/common';
import { IStationSearch } from 'src/types/station';
import { IPayloadGetUser, IUpdateUser, IUser, IUserAdd } from 'src/types/user';
import { toastMessage } from 'src/utils/toast';

export const checkExistEmail = createAsyncThunk<string, string>(
  'user/checkExistEmail',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await userApi.checkExistEmail(payload);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getUserList = createAsyncThunk<IPagination<IUser>, IPayloadGetUser>(
  'user/getUserList',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await userApi.getUserList(payload);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const addAdmin = createAsyncThunk<string, IUserAdd>(
  'user/addUser',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await userApi.addUser(payload);
      return data;
    } catch (error: any) {
      toastMessage.error(error.message);
      return rejectWithValue(error);
    }
  },
);

export const getUserDetail = createAsyncThunk<IUser, string>(
  'user/getUserDetail',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await userApi.getUserDetail(payload);
      return data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  },
);

export const updateUser = createAsyncThunk<IUser, { userId: string; user: IUpdateUser }>(
  'user/updateUser',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await userApi.updateUser(payload);
      return data;
    } catch (error: any) {
      toastMessage.error(error.message);

      return rejectWithValue(error);
    }
  },
);

export const deleteUser = createAsyncThunk<{ message: string }, string>(
  'user/deleteUser',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await userApi.deleteUser(payload);
      return data;
    } catch (error: any) {
      toastMessage.error(error?.message || 'Lỗi hệ thống');

      return rejectWithValue(error);
    }
  },
);
export const revokeAllSession = createAsyncThunk<{ message: string }, string>(
  'user/revokeAllSession',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await userApi.revokeAllSession(payload);
      return data;
    } catch (error: any) {
      toastMessage.error(error.message);

      return rejectWithValue(error);
    }
  },
);

export const sendActiveEmail = createAsyncThunk<any, string>(
  'user/sendActiveEmail',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await userApi.sendActiveEmail(payload);
      return data;
    } catch (error: any) {
      toastMessage.error(error.message);

      return rejectWithValue(error);
    }
  },
);

export const updateUserPassword = createAsyncThunk<any, { userId: string; password: string }>(
  'user/updateUserPassword',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await userApi.updateUserPassword(payload);
      return data;
    } catch (error: any) {
      toastMessage.error(error.message);

      return rejectWithValue(error);
    }
  },
);

//userStation

export const getMyStation = createAsyncThunk<{ id: string; name: string }[], IStationSearch>(
  'user/getMyStation',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await stationApi.getMyStation(payload);
      return data;
    } catch (error: any) {
      toastMessage.error(error.message);

      return rejectWithValue(error);
    }
  },
);

export const getAdminStationConfig = createAsyncThunk<
  { trackAll: boolean; stationList: { id: string; name: string }[] },
  string
>('user/getUserStationConfig', async (payload, { rejectWithValue }) => {
  try {
    const { data } = await stationApi.getUserStationConfig(payload);
    return data;
  } catch (error: any) {
    toastMessage.error(error.message);

    return rejectWithValue(error);
  }
});

export const configAdminStation = createAsyncThunk<
  string,
  { userId: string; trackAll: boolean; stationIds: string[] }
>('user/configUserStation', async (payload, { rejectWithValue }) => {
  try {
    const { data } = await stationApi.configUserStation(payload);
    return data;
  } catch (error: any) {
    toastMessage.error(error.message);

    return rejectWithValue(error);
  }
});

export const generateSession = createAsyncThunk<string, string>(
  'user/generateSession',
  async (userId, { rejectWithValue }) => {
    try {
      const { data } = await userApi.generateSession(userId);
      return data.token;
    } catch (error: any) {
      toastMessage.error(error.message);

      return rejectWithValue(error);
    }
  },
);

export const revokeGenerateSession = createAsyncThunk<
  { message: string },
  { userId: string; token: string }
>('user/revokeGenerateSession', async (payload, { rejectWithValue }) => {
  try {
    const { data } = await userApi.revokeGenerateSession(payload.userId, payload.token);
    return data;
  } catch (error: any) {
    toastMessage.error(error.message);

    return rejectWithValue(error);
  }
});
